import { useMemo } from 'react';
import useLocationsQuery from './useLocationsQuery';
import { isErrorResponse } from '@/services/typeguards';
import {
  FEATURED_CITIES,
  type CityBounds
} from '@goodneighbor/api/services/supportedCities';

export type FeaturedLocation = {
  key: string;
  displayName: string;
  shortName: string;
  eventCount: number;
  lat: number;
  lng: number;
  image: string;
  bounds: CityBounds;
};

export default function useFeaturedLocations() {
  const { data: locationsData, isLoading, error } = useLocationsQuery();

  const locations = useMemo(
    () =>
      locationsData && !isErrorResponse(locationsData)
        ? locationsData.data.locations
        : [],
    [locationsData]
  );

  const featuredLocations = useMemo(() => {
    return FEATURED_CITIES.map((cityConfig) => {
      const locationData = locations.find((loc) => loc.key === cityConfig.key);
      return {
        key: cityConfig.key,
        displayName:
          locationData?.displayName || cityConfig.shortName || cityConfig.key,
        shortName: cityConfig.shortName || cityConfig.key,
        eventCount: locationData?.eventCount || 0,
        lat: cityConfig.center.lat,
        lng: cityConfig.center.lng,
        image: cityConfig.image,
        bounds: cityConfig.bounds
      };
    });
  }, [locations]);

  return {
    featuredLocations,
    isLoading,
    error
  };
}
